import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import './mapButton.css';


export const MapButton = observer((props) => {
  const { text, dataCount, onClick, pressed, className, children, ...rest } = props;
  const buttonEl = useRef(null);

  function clickHandler(e) {
    onClick(props.value, e);
  }

  return (
    <a
      type="button"
      className={classnames(className, {
        'button-reset': true,
        'map-button': true,
        'map-button--pressed': rest.pressed,
      })}
      style={{ whiteSpace: 'nowrap' }}
      onClick={clickHandler}
      {...rest}
    >
      {text}
      {dataCount > 0 && <span className="map-button__ico">{dataCount}</span>}
      {children}
    </a>
  );
});

MapButton.propTypes = {
  text: PropTypes.element,
  value: PropTypes.string,
  pressed: PropTypes.bool,
};
